module.exports = "/static/assets/6dac3a9bb6825037e30afb338ad08a64.png";